import Icon from '../components/Icon.vue'

Icon.register({
  'won-sign': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M564 192h-62.7l-7.4 32h70.1c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-84.9l-42.1 182.7c-1.3 5.4-6.1 9.3-11.7 9.3h-56.8c-5.6 0-10.4-3.9-11.7-9.3l-42.4-182.7h-55.1l-42.3 182.7c-1.3 5.4-6.1 9.3-11.7 9.3h-56.8c-5.6 0-10.5-3.9-11.7-9.4l-40.9-182.6h-83.9c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h69.5l-7.2-32h-62.3c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h48l-18.1-80.7c-1.7-7.5 4-14.6 11.7-14.6h42.1c5.7 0 10.7 4 11.8 9.6l17.5 85.7h108.7l20-86c1.3-5.5 6.1-9.3 11.7-9.3h44c5.6 0 10.4 3.8 11.7 9.3l19.7 86h109.9l14.4-85.8c1.1-5.5 6-9.5 11.7-9.5h46.1c7.7 0 13.4 7.2 11.7 14.7l-18.6 80.6h48c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zM183.8 342l12.6-54h-38.8l11 54c5.1 25.2 6.8 47.2 6.8 47.2h1.1c0.5 0 1.1-21.4 7.3-47.2zM211.3 224l7.5-32h-80.8l6.5 32h66.8zM274.2 224h25.4l-2-8.6c-1.9-8-3.5-16-4.8-23.4h-11.8c-1.3 7.4-2.9 15.4-4.8 23.4zM405.1 342l11.5-54h-39.1l12.4 54c6.2 25.8 6.7 47.2 7.3 47.2h1.1s1.7-22 6.8-47.2zM430.3 224l6.9-32h-81.6l7.3 32h67.4z'
      }
    ]
  }
})
